import { h, Component } from 'preact'
import { GraphTitle } from '../GraphTitle'
import { Loader } from '../Loader'
import { Bar } from 'react-chartjs-2'
import { displayLegendsWithMarginBottom, getBrandBlue, getBrandBorderGrey } from '../utils'
import { ChartData, ChartTooltipItem } from 'chart.js'
import AnalyticsDateFormatter from '../AnalyticsDateFormatter'
import axios from 'axios'
import classNames from 'classnames'
import Button from '../../ui-components/Button'
import LinkIcon from '../../event-overview/assets/linkIcon'
displayLegendsWithMarginBottom()

interface Props {
  shouldChartRedraw: boolean,
  startDate: Date,
  endDate: Date,
  selectedRoles: Array<string>,
  selectedCategories: Array<string>,
  selectedContentTypes: Array<string>,
  isSyncTicketDataActive: boolean
}

interface DateItem {
  time: string,
  count: number
}

interface State {
  isLoading: boolean,
  selfServiceScoreOverTime: Array<DateItem>
}

class SelfServiceScoreOverTime extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.setState({
      isLoading: true,
      selfServiceScoreOverTime: []
    })
  }

  async componentDidUpdate (prevProps: Props, prevState: State) {
    if (this.props.startDate !== prevProps.startDate || this.props.endDate !== prevProps.endDate || this.props.selectedRoles !== prevProps.selectedRoles || this.props.selectedContentTypes !== prevProps.selectedContentTypes || this.props.selectedCategories !== prevProps.selectedCategories) {
      await this.fetchData()
    }
  }

  async fetchData () {
    const { startDate, endDate, selectedRoles, selectedCategories, selectedContentTypes } = this.props
    this.setState({ isLoading: true })
    const { data } = await axios.post('/analyticsV2/selfServiceScoreOverTime', {
      filters: {
        start: AnalyticsDateFormatter.formatDate(startDate),
        end: AnalyticsDateFormatter.formatDate(endDate, false),
        roles: selectedRoles,
        categories: selectedCategories,
        contentTypes: selectedContentTypes
      }
    })
    this.setState({
      selfServiceScoreOverTime: data,
      isLoading: false
    })
  }

  render ({ shouldChartRedraw, isSyncTicketDataActive }: Props, { isLoading, selfServiceScoreOverTime }: State) {
    return <div className={classNames('graph-row', { 'no-data': !isSyncTicketDataActive })}>
      <GraphTitle
        title='Self-service score'
        tooltipMessage='The ratio of unique visitors who viewed help content to unique users who created a ticket in the selected time period over time.' />
      {!isSyncTicketDataActive ? <div class='data-not-tracked-text'>
        No tracked data
        <div>
          <a target='_blank' href='/settings/integrations/zendesk' className='qa-link'>
            <Button default class='integration-page-link' >Add Zendesk integration <LinkIcon size={14} color={'#2B3346'} /></Button>
          </a>
        </div>
      </div> : isLoading ? <Loader /> : <Bar redraw={shouldChartRedraw} data={{
        datasets: [{
          label: 'Ratio of unique visitors who viewed help content to unique users who created a ticket',
          fill: false,
          maxBarThickness: 500,
          data: selfServiceScoreOverTime.map((d: DateItem) => {
            return { x: d.time, y: d.count }
          }),
          backgroundColor: getBrandBlue()
        }]
      }} options={{
        title: {
          display: false
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 24
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          intersect: false,
          mode: 'nearest',
          callbacks: {
            title (item: ChartTooltipItem[], data: ChartData): string | string[] {
              if (item.length > 0 && item[0].label) {
                const date = new Date(item[0].label.substr(0, 10))
                return new Intl.DateTimeFormat('en', { month: 'short', year: 'numeric' }).format(date)
              }
              return ''
            }
          }
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            type: 'time',
            offset: true,
            time: {
              unit: 'month'
            }
          }],
          yAxes: [{
            gridLines: {
              borderDash: [8, 4],
              color: getBrandBorderGrey(),
              drawBorder: false
            },
            ticks: {
              padding: 16,
              beginAtZero: true
            }
          }]
        }
      }} />}
    </div>
  }
}

export default SelfServiceScoreOverTime
